import AbstractEntity from "../AbstractEntity";

export default class DefaultItem extends AbstractEntity {
    static SHIFTING = 11;
    static MAIN_WORK = 12;

    _id;
    _name;
    _buyPrice;
    _sellPrice;
    _enabled;
    _emissionFactor;


    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getBuyPrice() {
        return this._buyPrice;
    }

    getSellPrice() {
        return this._sellPrice;
    }

    isEnabled() {
        return this._enabled;
    }

    getEmissionFactor() {
        return this._emissionFactor;
    }

    getClassName() {
        return "default_item";
    }
}